module.exports = new __parcel__URL__("amplitude.a852020e.svg").toString();